(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/graph/graph-view.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/graph/graph-view.js'); 
'use strict';

svs.sport.result_boxes.graph.GraphView = Backbone.Marionette.View.extend({
  onRender: function() {
    var gridStartX = 60; 
    if ($('.swipe-boxes-multiple').outerWidth(true) < 375) {
      gridStartX =
          gridStartX -
          ($('.trend-graph-container').outerWidth(true) -
            $('.trend-graph-container').width()) /
            2;
    }

    if (!this.graph) {
      this.graph = new svs.sport.Graph({
        points: this.model.get('points'),
        datePoints: this.model.get('datePoints'),
        container: this.el,
        autoWidth: false,
        gridStartX: gridStartX
      });
    }
  },
  shouldAnimate: true,
  onAttach: function() {
    this.graph.draw(this.shouldAnimate);
    this.shouldAnimate = false;
  },
  template: function() {
    return '';
  },
  clear: function() {
    this.graph.clear();
  },
  addPoints: function(points, keepOldPoints) {
    this.graph.addPoints(points, keepOldPoints);
  }
});

 })(window);